<div class="container p-0 min-w-[28rem]" *ngIf="formGroup">
  <mat-dialog-content class="text-black text-base">
    <div class="modal-dialog p-10">
      <ng-container *ngIf="!displaySuccess; else successMessage">
        <div class="modal-content w-[700px]">
          <div class="text-center pb-8">
            <h4 class="text-2xl text-dark_blue">
              Complete eSignature Attestation
            </h4>
          </div>
          <div class="modal-body flex flex-col" [formGroup]="formGroup">
            <div>
              <div class="mb-4">
                Please complete setting up your eSignature profile before
                proceed to the Rehab Connect tool. Please review attestation below
                which will be used in the e-Signature process and indicate your
                acceptance.
              </div>
              <div class="mb-4">
                I certify that the accompanying information accurately reflects
                the clinical information and performance for this patient and
                that I personally delivered, supervised, or reviewed the
                services and supporting information according to the patient's
                approved plan of care and applicable laws and regulations. To
                the best of my knowledge, this documentation meets the Medicare,
                Medicaid and state practice law requirements. I understand my
                documentation will be used as a basis for receipt of payment
                from federally funded healthcare programs or other third party
                payors.
              </div>
            </div>
            <div class="mb-4">
              <mat-checkbox formControlName="acknowledgement"
                >I acknowledge the signature attestation above.</mat-checkbox
              >
            </div>
            <div class="flex flex-row gap-4">
              <app-input
                class="w-1/2"
                [formGroup]="formGroup"
                formControlName="signature"
                placeholder="Enter signature"
                [required]="true"
                type="text"
              ></app-input>
              <app-input
                class="w-1/2"
                [formGroup]="formGroup"
                formControlName="confirmSignature"
                placeholder="Confirm signature"
                [required]="true"
                type="text"
              ></app-input>
            </div>
            <span
              class="text-red-500 h-4"
              [class.invisible]="!formGroup.errors?.['signatureMismatch'] && !formGroup.errors?.['missingSignature']"
            >
              <ng-container
                *ngIf="formGroup.errors?.['signatureMismatch'] else missingSignature"
                >The entered signatures do not match. Please try
                again.</ng-container
              >
              <ng-template #missingSignature
                >Please complete both signature fields before
                continuing.</ng-template
              >
            </span>
          </div>
          <div class="modal-footer flex flex-col items-center gap-4 mt-4">
            <thera-button
              [config]="continueButtonConfig"
              [disabled]="formGroup.valid === false"
              (clicked)="continue()"
            >
            </thera-button>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>
</div>
<ng-template #successMessage>
  <div class="modal-content min-w-96">
    <div class="text-center pb-8">
      <h4 class="text-2xl text-dark_blue">eSignature Set Up Complete</h4>
    </div>
    <div class="modal-body flex flex-col text-center">
      <div class="mb-4">
        Thank you. You have successfully <br />
        set up your eSignature profile.
      </div>
    </div>
    <div class="modal-footer flex flex-col items-center gap-4 mt-4">
      <thera-button [config]="okButtonConfig" (clicked)="close()">
      </thera-button>
    </div>
  </div>
</ng-template>
